
var Menu = function() {
    var currentScrollTop = 0;

    $(document).ready(function() {
    //     var scrollBarWidth = getScrollbarWidth();

		// $('.navbar-main').on('show.bs.offcanvas', function(e) {
		// 	$(this).removeClass('rs_skip');
		// }).on('hide.bs.offcanvas', function(e) {
		// 	$(this).addClass('rs_skip');
		// }).find('.speak').on('click', function(e) {
		// 	$('.navbar-main .collapse').collapse('show');
		// });

        // $('.navbar-toggle-btn, .has-dropdown').on('click', function(e) {
        // 	e.preventDefault();
		// });

        // var $collapsable = $('.navbar-dropdown, .navbar-collapse, .navbar-search-collapse');
		//
        // $collapsable.on('show.bs.collapse', function(e) {
		// 	$(this).addClass('open');
        // 	$collapsable.not($(this)).collapse('hide');
		// 	$('.dropdown-menu.showing').removeClass('showing');
		// 	var $element = $(this);
		//
        //     openBackdrop('dropdown-backdrop', function() {
        //     	$element.collapse('hide');
		// 	});
		//
        // }).on('hide.bs.collapse', function(e) {
		// 	$(this).removeClass('open');
		//
        // 	// setTimeout(function() {
		// 		if ($collapsable.filter('.collapsing, .open').length <= 1) {
		// 			closeBackdrop('dropdown-backdrop');
		// 		}
		// 	// }, 1);
        // });

		// $('.dropdown').each(function() {
		// 	var $dropdown      = $(this);
		// 	var $toggleMobile  = $dropdown.find('.dropdown-toggler-mobile').first();
		// 	var $menu          = $dropdown.find('.dropdown-menu').first();
		//
		// 	if ($menu.length === 0) {
		// 		return;
		// 	}
		//
		// 	$dropdown.on('click', function(e) {
		// 		var $clickElement = $(e.target);
		//
		// 		if ($clickElement.hasClass('.dropdown-toggler-mobile') || $clickElement.closest('.dropdown-toggler-mobile').length > 0) {
		// 			e.preventDefault();
		// 		}
		// 	});
		//
		// 	$toggleMobile.on('click', function(e) {
		// 		if ($dropdown.hasClass('dropdown-open')) {
		// 			$dropdown.removeClass('dropdown-open');
		// 			$menu.stop(false, false).slideUp();
		//
		// 		} else {
		// 			$dropdown.addClass('dropdown-open');
		// 			$menu.stop(false, false).slideDown();
		// 		}
		// 	});
		// });

		// Voor desktop alleen level 1 dropdown gebruiken
	// 	$('.level-1 > .dropdown').each(function() {
	// 		// var $dropdown      = $(this);
	// 		// var $toggleMobile  = $dropdown.find('.dropdown-toggler-mobile').first();
	// 		// var $menu          = $dropdown.find('.dropdown-menu').first();
	//
	//
	// 		// KEUZE 1: ON CLICK
	// 		// $dropdown.find('> a').on('click', function(e) {
	// 		// 	e.preventDefault();
	// 		// 	e.stopPropagation();
	// 		//
	// 		// 	if ($toggleMobile.is(':visible')) {
	// 		// 		if ($dropdown.hasClass('dropdown-open')) {
	// 		// 			$dropdown.removeClass('dropdown-open');
	// 		// 			$menu.stop(false, false).slideUp();
	// 		//
	// 		// 		} else {
	// 		// 			$dropdown.addClass('dropdown-open');
	// 		// 			$menu.stop(false, false).slideDown();
	// 		// 		}
	// 		//
	// 		// 		return;
	// 		// 	}
	// 		//
	// 		// 	// Als de dropdown buiten het scherm dreigt te vallen, dan rechts uitlijnen
	// 		// 	if ($dropdown.offset().left + $menu.width() > $(window).width()) {
	// 		// 		$menu.addClass('align-right');
	// 		// 	} else {
	// 		// 		$menu.removeClass('align-right');
	// 		// 	}
	// 		//
	// 		// 	$collapsable.collapse('hide');
	// 		// 	$('.dropdown-menu.showing').removeClass('showing');
	// 		// 	$menu.addClass('showing');
	// 		// 	openBackdrop('dropdown-backdrop');
	// 		// });
	//
	// 		// $(document).on('click', function(e) {
	// 		// 	if ($(e.target).closest('.dropdown-menu.showing').length > 0) {
	// 		// 		return;
	// 		// 	}
	// 		//
	// 		// 	var $visibleMenu = $('.dropdown-menu.showing');
	// 		//
	// 		// 	if ($visibleMenu.length > 0) {
	// 		// 		if ($collapsable.filter('.open').length <= 1) {
	// 		// 			closeBackdrop('dropdown-backdrop');
	// 		// 		}
	// 		//
	// 		// 		$visibleMenu.removeClass('showing');
	// 		// 	}
	// 		// });
	//
	//
	// 		// KEUZE 2: ON HOVER
	// 		// $dropdown.on('mouseenter', function(e) {
	// 		// 	if ($toggleMobile.is(':visible')) {
	// 		// 		return;
	// 		// 	}
	// 		//
	// 		// 	// Timeout toepassen om een eventuele click event eerst te kunnen behandelen
	// 		// 	setTimeout(function() {
	// 		// 		// Als de dropdown buiten het scherm dreigt te vallen, dan rechts uitlijnen
	// 		// 		if ($dropdown.offset().left + $menu.width() > $(window).width()) {
	// 		// 			$menu.addClass('align-right');
	// 		// 		} else {
	// 		// 			$menu.removeClass('align-right');
	// 		// 		}
	// 		//
	// 		// 		openBackdrop('dropdown-backdrop');
	// 		// 		$menu.addClass('showing');
	// 		// 	}, 5);
	// 		//
	// 		// }).on('mouseleave', function(e) {
	// 		// 	if ($toggleMobile.is(':visible')) {
	// 		// 		return;
	// 		// 	}
	// 		//
	// 		// 	closeBackdrop('dropdown-backdrop');
	// 		// 	$menu.removeClass('showing');
	// 		// });
	// 	});
	//
	//
    //     $('.navbar-search-collapse').on('show.bs.collapse', function(e) {
    //     	var $element = $(this);
	//
    //     	setTimeout(function() {
    //     		$element.find('.form-control').trigger('focus');
	// 		}, 500);
	// 	});
	//
    //     // Collapse menu
    //     $('.navbar-main-collapse').on('show.bs.collapse', function(e) {
    //         // $('.navbar-search').collapse('hide');
    //         $('.navbar-toggle-btn').addClass('active');
    //         // $('body').addClass('scroll-disabled').css('margin-right', getScrollbarWidth());
	//
    //         // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
    //         // scrolltop opslaan en de body overflow hidden geven.
    //         // setScrollTop();
    //         // setTimeout(function() {
    //         //     $('body').addClass('scroll-disabled');
    //         //     $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
    //         // }, 300);
	//
    //     }).on('hide.bs.collapse', function(e) {
    //         $('.navbar-toggle-btn').removeClass('active');
	//
    //         // Bij het sluiten van het menu de body weer overflow scroll geven
    //         // en de opgeslagen scrolltop laden.
    //         // $('body').removeClass('scroll-disabled').css('margin-right', 0);
    //         // $('.navbar-fixed-top').css('margin-right', 0);
    //         // window.scrollTop = currentScrollTop;
    //     });
	//
    //     // Slide toggle submenu
	// 	$('.navbar-main .has-submenu > a .item-open').on('click', function(e) {
	// 		// if ($(window).width() > 991) {
	// 		// 	return;
	// 		// }
	//
	// 		// var $submenu = $(this).closest('li').find('.navbar-subnav');
	//
	// 		// if (!$submenu.is(':visible')) {
	// 		// 	e.preventDefault();
	// 		// 	$submenu.slideToggle('fast');
	// 		// }
	//
	//
	// 		var $item    = $(this).closest('li');
	// 		var $submenu = $item.find('> .navbar-subnav');
	//
	// 		e.preventDefault();
	//
	// 		if (!$submenu.is(':visible')) {
	// 			$item.addClass('submenu-open');
	// 			$submenu.slideDown('fast');
	//
	// 		} else {
	// 			$item.removeClass('submenu-open');
	// 			$submenu.slideUp('fast');
	// 		}
	// 	});
	//
	// 	// If a main menu link was clicked and the available submenu is not visible, show the submenu and stop navigation.
	// 	$('.navbar-main .has-submenu > a').on('click', function(e) {
	// 		var $submenu = $(this).parent().find('.navbar-subnav');
	//
	// 		if (!$submenu.is(':visible') || $submenu.height() == 0) {
	// 			e.preventDefault();
	// 			$submenu.slideDown('fast');
	//
	// 			$(this).find('i').removeClass('fa-chevron-down');
	// 			$(this).find('i').addClass('fa-chevron-up');
	// 		}
	// 	});
	//
	// 	$('.navbar-main .submenu-collapse').on('click', function(e) {
	// 		var $submenu = $(this).parent().parent().parent().find('.navbar-subnav');
	//
	// 		if (!$submenu.is(':visible') || $submenu.height() > 0) {
	// 			e.preventDefault();
	// 			$submenu.slideUp('fast');
	//
	// 			$(this).find('i').removeClass('fa-chevron-up');
	// 			$(this).find('i').addClass('fa-chevron-down');
	// 		}
	// 	});
	//
	// 	// Navbar search
	// 	// $('.open-navbar-search').on('click', function(e) {
	// 	// 	e.preventDefault();
	// 	// 	$(this).closest('.navbar-search').addClass('focus').find('input').focus();
	// 	// });
	// 	// $(document).on('click', function() {
	// 	// 	$('.navbar-search').removeClass('focus');
	// 	// 	$('.navbar-dropdown.in').collapse('hide');
	// 	// 	$('.navbar-search').collapse('hide')
	// 	// });
	// 	// $('.navbar-search').on('click', function(e) {
	// 	// 	e.stopPropagation();
	// 	// });
	//
    //     // Collapse search
    //     // $('.navbar-search').on('show.bs.collapse', function() {
    //     //     $('.navbar-custom-collapse').collapse('hide');
    //     //     $('.navbar-search-toggle').addClass('active');
	// 	//
    //     //     setTimeout(function() {
    //     //         $('.navbar-search .form-control').focus();
    //     //     }, 500);
    //     // });
    //     // $('.navbar-search').on('hide.bs.collapse', function() {
    //     //     $('.navbar-search-toggle').removeClass('active');
    //     //     $('body').removeClass('scroll-disabled');
    //     //     window.scrollTop = currentScrollTop;
    //     // });
	//
    //     // Popin dropdown menus
    //     $('a[data-target-popin-menu]').on('click', function(e) {
    //         e.stopPropagation();
    //         e.preventDefault();
	//
    //         if ($(this).hasClass('disabled')) {
    //             return;
    //         }
	//
    //         var showContainer = $(this).data('target-popin-menu');
    //         $('.nav-popin-menu').not(showContainer).removeClass('active');
	//
    //         if ($(showContainer).hasClass('active')) {
    //             $(showContainer).removeClass('active');
	//
    //         } else {
    //             $(showContainer).addClass('active');
    //             $(window).trigger('resize-popin-menu');
    //         }
    //     });
    //     $(document).on('click', function(e) {
    //         $('.nav-popin-menu').removeClass('active');
    //     });
    //     $('.nav-popin-menu').on('click', function(e) {
    //         // e.stopPropagation();
    //     });
    //     // $(window).on('resize resize-popin-menu', function() {
    //     //     $('a[data-target-popin-menu]').each(function() {
    //     //         var $target = $($(this).data('target-popin-menu'));
	// 	//
    //     //         if (!$target.hasClass('active')) {
    //     //             return;
    //     //         }
	// 	//
    //     //         if ($(window).width() < 768) {
	// 	// 			$target.css({
	// 	// 				'right': 0,
	// 	// 				'left': 'auto'
	// 	// 			});
	// 	//
    //     //         } else {
	// 	// 			$target.css({
	// 	// 				'left': 0,
	// 	// 				'right': 'auto'
	// 	// 			});
	// 	// 		}
	// 	//
    //     //         $target.css('top', $(this).position().top + $(this).height());
    //     //     });
    //     // });
    });

    // $(document).keyup(function(e) {
    //     if (e.keyCode == 27) {
    //         $('.navbar-dropdown.show').collapse('hide');
    //         $('.navbar-search').removeClass('focus');
    //     }
    // });

    // var setScrollTop = function() {
    //     currentScrollTop = window.scrollTop;
    // };
	//
    // var getScrollbarWidth = function() {
    //     var $div = $('<div />').css({
    //         width: '100px',
    //         height: '100px',
    //         overflow: 'scroll',
    //         position: 'absolute',
    //         top: '-9999px',
    //     }).appendTo($('body'));
	//
    //     var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    //     $div.remove();
	//
    //     return scrollbarWidth;
    // };

    return this;
}();


$(function() {

	// $(window).on('resize', function() {
	// 	if ($(document).width() < 976) {
	// 		$('.navbar-dropdown').addClass('mobile-dropdown');
	// 	} else {
	// 		$('.navbar-dropdown').removeClass('mobile-dropdown');
	// 	}
	//
	// 	$('.has-submenu .navbar-subnav').show();
	// 	$('.mobile-dropdown .has-submenu .navbar-subnav').hide();
	// 	$('.mobile-dropdown .has-submenu.active .navbar-subnav').show();
	// }).trigger('resize');

	// $('.item-open').on('click', function() {
	// 	var $chevron = $(this).find('i');
	// 	var $submenu = $(this).parents('.has-submenu').find('ul.navbar-subnav');
	//
	// 	if (!$submenu.is(':visible')) {
	// 		$chevron.removeClass('fa-chevron-down').addClass('fa-chevron-up');
	// 		$submenu.slideDown('fast');
	// 	} else {
	// 		$chevron.removeClass('fa-chevron-up').addClass('fa-chevron-down');
	// 		$submenu.slideUp('fast');
	// 	}
	// });
});
